import ResizeTextarea from "react-textarea-autosize";
import {Textarea} from "@chakra-ui/react";
import React from "react";

export const AutoResizeTextarea = React.forwardRef((props: any, ref: any) => {
    return (
        <Textarea
            minH="unset"
            variant="outline"
            overflow="hidden"
            w="100%"
            colorScheme={"brand.green"}
            resize="none"
            ref={ref}
            focusBorderColor={"brand.green.500"}
            minRows={1}
            as={ResizeTextarea}
            {...props}
        />
    );
});